<template>
    <div>
      <transition name="payTips">
        <div class="pay-tips" v-show="isShowWeiXin">
          基于微信安全策略原因，暂不支持在微信内打开支付链接。
          请点击右上角，选择“在浏览器中打开”。
          或者复制链接到手机浏览器中打开支付页面。
        </div>
      </transition>
  
  
  
        <div class="pay-content">
  
        </div>
    </div>
  </template>
  
  <script>
    // import reloadUserInfo from '@/js/reloadUserInfo'
    export default{
      data(){
        return {
          isShowWeiXin:false,
        }
      },
      mounted() {
          this.goToPay();
       },
       methods:{
         //跳转
         goToPay(){
           var queryObj = this.$route.query || {};
            if(queryObj.uid){
              //存储token用于，获取订单
              this.$common.sessionset('access_token',queryObj.uid);
              this.$common.localset('access_token',queryObj.uid);
            
              if(queryObj.routeTarget =='minmetals'){
                this.$router.replace({
                    path:"/payFor5k",
                    query:{
                    ...queryObj
                    }
                })
              }else{
                this.$router.replace({
                    path:"/yjDetail/payment",
                    query:{
                    ...queryObj
                    }
                })
              }

            }
         }
       }
  
    }
  </script>
  
  <style scoped>
  
  
      .pay-tips{
        font-size: 12px;
        padding: 10px 15px;
        color: white;
        background-color: dimgrey;
        text-align: left;
      }
  
          /* 设置持续时间和动画函数 */
      .payTips-enter-active,.payTips-leave-active {
        transition: all .8s ease;
        }
      .payTips-enter, .payTips-leave-to{
        transform: translateY(-100%);
        /* opacity: 0; */
      }
      .pay-content{
        padding: 10px 15px;
        font-size: 14px;
        text-align: left;
      }
  </style>
  